import React, { FC } from 'react';

type Props = {
    size?: number;
};

export const ShareApi: FC<Props> = ({ size }) => {
    function callNativeAppShareAPI() {
        // @ts-ignore
        shareToSNS.postMessage(JSON.stringify({
            title: document.title,
            url: window.location.protocol + '//' + window.location.host + window.location.pathname
        }));
    }

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        const ua = navigator.userAgent.toLowerCase();
        const isApp = ua.includes('salon.jp');
        if (isApp) {
            callNativeAppShareAPI();
        } else {
            navigator
                .share({
                    title: document.title,
                    text: window.location.protocol + '//' + window.location.host + window.location.pathname,
                    url: window.location.protocol + '//' + window.location.host + window.location.pathname
                })
                .catch(function (err) {
                    // pass
                });
        }
    }

    return (
        <button onClick={handleClick}>
            <img
                width={`${size ? size : 56}px`}
                height={`${size ? size : 56}px`}
                src={`${process.env.PUBLIC_URL}/img/sp/common/icon_share.png`}
            />

            <style jsx>{`
                button {
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: ${size ? size : 56}px;
                    height: ${size ? size : 56}px;
                    border-radius: 50%;
                    border: none;
                    padding: 0;
                    background: #fff;
                }
            `}</style>
        </button>
    );
}
